import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from "../../../api/api";
import '../styles/ParentPanel.css';

// Icons
import dashboardIcon from '../icons/dashboard.png';
import logoutIcon from '../icons/logout.png';
import classIcon from '../icons/class.png';
import feesIcon from '../icons/fees.png';
import ticketIcon from '../icons/ticket.png';
import timetableIcon from '../icons/timetable.png';
import noticeIcon from '../icons/notice.png';
import resultsIcon from '../icons/results.png';
import transportIcon from '../icons/transport.png';
import examIcon from '../icons/exam.png';
import homeIcon from '../icons/homework.svg';
import class1Icon from '../icons/class.svg';
import assignmentIcon from '../icons/assignment.svg';
import booksIcon from '../icons/books.svg';

const iconMap = {
  'Parent Dashboard': dashboardIcon,
  'Join Live Class': classIcon,
  'Pay Fees': feesIcon,
  'School Timetable': timetableIcon,
  'Home Work': homeIcon,
  'Class Work': class1Icon,
  'Assignments': assignmentIcon,
  'See Notice': noticeIcon,
  'See Results': resultsIcon,
  'Online Exam': examIcon,
  'See Booklist': booksIcon,
  'Transport': transportIcon,
  'Raise a Ticket': ticketIcon,
};

const ParentPanel = ({ onToggle, hideToggle = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location?.pathname || "/");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [modules, setModules] = useState([]);

  useEffect(() => {
    setActivePath(location?.pathname || "/");
  }, [location]);

  const studentId = localStorage.getItem("userId") || "";
  const schoolId = localStorage.getItem("schoolId") || "";

  // Fetch enabled parent modules
  useEffect(() => {
    const fetchModules = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token || !schoolId) return;

        const res = await api.get(`/api/modules/${schoolId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

       const enabledModules = res.data.filter(
  (m) => m.role === 'parent' && m.enabled
);

        setModules(enabledModules);
      } catch (err) {
        console.error("Error fetching modules:", err);
      }
    };

    fetchModules();
  }, [schoolId]);

  const handleNavigate = (path) => {
    setActivePath(path);
    navigate(path);
    if (window.innerWidth <= 768) document.querySelector('.parent-panel').classList.remove('expanded');
  };

  const handleLogout = () => {
    const role = localStorage.getItem('role') || 'parent';
    localStorage.clear();
    navigate(`/portal/${role}`);
  };

  const toggleSidebar = () => {
    const panel = document.querySelector('.parent-panel');
    if (window.innerWidth <= 768) panel.classList.toggle('expanded');
    else {
      setIsCollapsed(!isCollapsed);
      if (onToggle) onToggle(!isCollapsed);
    }
  };

  return (
    <div className="parent-panel-wrapper">
      {!hideToggle && (
        <div className={`toggle-button-outside ${isCollapsed ? 'collapsed' : ''}`} onClick={toggleSidebar}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      )}

      <div className={`parent-panel ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="parent-panel-header">
          <div className="panel-header-overlay">
            {!isCollapsed && <span className="header-title">Parent Panel</span>}
          </div>
        </div>

        <div className="parent-list">
          {modules.map((mod) => {
            const path = mod.path?.replace(":id", studentId) || "/";
            return (
              <button
                key={mod.school_module_id}
                className={activePath === path ? 'active' : ''}
                onClick={() => handleNavigate(path)}
              >
                <img
                  src={iconMap[mod.name] || dashboardIcon}
                  alt={mod.name}
                  className={`icon ${activePath === path ? 'active-icon' : ''}`}
                />
                {!isCollapsed && (
                  <span className="parent-button-content">
                    {mod.name}<span className="parent-arrow">&gt;</span>
                  </span>
                )}
              </button>
            );
          })}

          <button onClick={handleLogout}>
            <img src={logoutIcon} alt="Logout" className="icon" />
            {!isCollapsed && (
              <span className="parent-button-content">
                Logout<span className="parent-arrow">&gt;</span>
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ParentPanel;